const zhCN = {
  backBtn: '返回',
  submitBtn: '提交',
  uploadSuccess: '上传成功！',
  uploadFail: '上传失败！',

  standbyTitle: '待机设置',

  screenTimeout: '进入待机时间',
  screenTimeoutTxt: '请选择进入待机时间',
  screenTimeoutBlank: '请选择进入待机时间！',
  option_30s: '30秒',
  option_1m: '1分钟',
  option_5m: '5分钟',
  option_10m: '10分钟',
  option_30m: '30分钟',
  option_Non: '不待机',

  standbyMode: '待机状态表现',
  standbyModeTxt: '请选择待机状态表现',
  standbyModeBlank: '请选择待机状态表现！',
  option_display: '息屏',
  option_defaultVideo: '默认视频',
  option_customPictures: '自定义图片',
  option_customVideo: '自定义视频',

  standbyVideo: '待机视频',
  standbyVideoBlank: '请上传待机视频！',
  uploadVideoBtn: '上传待机视频',

  standbyImage: '待机图片',
  standbyImageBlank: '请上传待机图片！',
  uploadImageBtn: '上传待机图片',

  standbyBrightnessType: '待机亮度类型',
  standbyBrightnessTypeTxt: '请选择待机亮度类型',
  standbyBrightnessTypeBlank: '请选择待机亮度类型！',
  option_followSystem: '跟随系统',
  option_userDefined: '自定义',

  standbyBrightness: '待机亮度',
  standbyBrightnessBlank: '请选择待机亮度！',

  dateAndTimeTitle: '时间与日期',

  showDateAndTime: '是否显示时间与日期',
  showDateAndTimeTxt: '请选择是否显示时间与日期',
  showDateAndTimeBlank: '请选择是否显示时间与日期！',
  option_true: '是',
  options_false: '否',

  syncWay: '同步方式',
  syncWayTxt: '请选择同步方式',
  syncWayBlank: '请选择同步方式！',
  option_serverSync: '与服务器同步',
  option_manualSettings: '手动设置',

  setDateAndTime: '自定义时间与日期',
  setDateAndTimeTxt: '请选择时间与日期',
  setDateAndTimeBlank: '请选择时间与日期！',

  dateFormat: '日期显示格式',
  dateFormatTxt: '请选择日期显示格式',
  dateFormatTBlank: '请选择日期显示格式！',

  timeFormat: '时间显示格式',
  timeFormatTxt: '请选择时间显示格式',
  timeFormatBlank: '请选择时间显示格式！',
  option_12h: '12小时制',
  option_24h: '24小时制',

  companyInfoTitle: '公司信息',

  showCompanyInfo: '是否显示公司信息',
  showCompanyInfoTxt: '请选择是否显示公司信息',
  showCompanyInfoWarning: '请选择是否显示公司信息！',

  companyName: '公司名称',
  companyNameTxt: '请输入公司名称',
  companyNameBlank: '请输入公司名称！',
  companyNameWarning: '最多输入40个字！',

  companyLogo: '公司Logo',
  companyLogoBlank: '请上传公司Logo！',
  uploadLogoBtn: '上传公司Logo',

  settingLanguage: '语言设置',
  settingLanguageTxt: '请选择语言',
  settingLanguageWarning: '请选择语言！',
  option_cn: '简体中文',
  option_us: 'English',

  voiceBroadcastTitle: '语音播报',

  enableVoiceBroadcast: '是否启用语音播报',
  enableVoiceBroadcastTxt: '请选择是否启用语音播报',
  enableVoiceBroadcastBlank: '请选择是否启用语音播报！',

  S_cardRecogVoice: '门禁卡识别成功语音',
  S_cardRecogVoiceTxt: '请输入门禁卡识别成功语音',
  S_cardRecogVoiceBlank: '请输入门禁卡识别成功语音！',
  S_cardRecogVoiceWarning: '最多输入20个字！',
  S_cardRecogVoiceDefault: '识别成功',

  F_cardRecogVoice: '门禁卡识别失败语音',
  F_cardRecogVoiceTxt: '请输入门禁卡识别失败语音',
  F_cardRecogVoiceBlank: '请输入门禁卡识别失败语音！',
  F_cardRecogVoiceWarning: '最多输入20个字！',
  F_cardRecogVoiceDefault: '无效卡',

  faceRecogVoice: '人脸识别中语音',
  faceRecogVoiceTxt: '请输入人脸识别中语音',
  faceRecogVoiceBlank: '请输入人脸识别中语音！',
  faceRecogVoiceWarning: '最多输入20个字！',
  faceRecogVoiceDefault: '识别中',

  S_faceRecogVoice: '人脸识别成功语音',
  S_faceRecogVoiceTxt: '请输入人脸识别成功语音',
  S_faceRecogVoiceBlank: '请输入人脸识别成功语音！',
  S_faceRecogVoiceWarning: '最多输入20个字！',
  S_faceRecogVoiceDefault: '识别成功',

  F_faceRecogVoice: '人脸识别失败语音',
  F_faceRecogVoiceTxt: '请输入人脸识别失败语音',
  F_faceRecogVoiceBlank: '请输入人脸识别失败语音！',
  F_faceRecogVoiceWarning: '最多输入20个字！',
  F_faceRecogVoiceDefault: '识别失败',
  
  noMaskVoice: '未佩戴口罩语音',
  noMaskVoiceTxt: '请输入未佩戴口罩语音',
  noMaskVoiceBlank: '请输入未佩戴口罩语音！',
  noMaskVoiceWarning: '最多输入20个字！',
  noMaskVoiceDefault: '请佩戴口罩',

  normothermiaVoice: '体温正常语音',
  normothermiaVoiceTxt: '请输入体温正常语音',
  normothermiaVoiceBlank: '请输入体温正常语音！',
  normothermiaVoiceWarning: '最多输入20个字！',
  normothermiaVoiceDefault: '体温正常',

  abnormothermiaVoice: '体温异常语音',
  abnormothermiaVoiceTxt: '请输入体温异常语音',
  abnormothermiaVoiceBlank: '请输入体温异常语音！',
  abnormothermiaVoiceWarning: '最多输入20个字！',
  abnormothermiaVoiceDefault: '体温异常',

  invalidTimeVoice: '开门时间范围外语音',
  invalidTimeVoiceTxt: '请输入开门时间范围外语音',
  invalidTimeVoiceBlank: '请输入开门时间范围外语音！',
  invalidTimeVoiceWarning: '最多输入20个字！',
  invalidTimeVoiceDefault: '不在有效开门时间',

  logCnfigTitle: '日志配置',

  saveDeviceWorkLog: '是否保存设备工作日志',
  saveDeviceWorkLogTxt: '请选择是否保存设备工作日志',
  saveDeviceWorkLogBlank: '请选择是否保存设备工作日志！',

  saveUserActionsLog: '是否保存用户操作日志',
  saveUserActionsLogTxt: '请选择是否保存用户操作日志',
  saveUserActionsLogBlank: '请选择是否保存用户操作日志！',

  saveDeviceAlarmLog: '是否保存设备报警日志',
  saveDeviceAlarmLogTxt: '请选择是否保存设备报警日志',
  saveDeviceAlarmLogBlank: '请选择是否保存设备报警日志！',

  logRetentionDays: '日志保留天数',
  logRetentionDaysBlank: '请设置日志保留天数！'
}
const enUS = {
  backBtn: 'Back',
  submitBtn: 'Submit',
  uploadSuccess: 'upload successfully!',
  uploadFail: 'upload failed!',

  standbyTitle: 'Standby settings',

  screenTimeout: 'Screen Timeout',
  screenTimeoutTxt: 'Choose screen timeout',
  screenTimeoutBlank: 'Screen timeout can\'t be blank!',
  option_30s: '30 seconds',
  option_1m: '1 minute',
  option_5m: '5 minute',
  option_10m: '10 minute',
  option_30m: '30 minute',
  option_Non: 'Non-standby',

  standbyMode: 'Standby Mode',
  standbyModeTxt: 'Choose standby mode',
  standbyModeBlank: 'Standby mode can\'t be blank!',
  option_display: 'Display',
  option_defaultVideo: 'Default Video',
  option_customPictures: 'Custom Pictures',
  option_customVideo: 'Custom Video',

  standbyVideo: 'Standby Video',
  standbyVideoBlank: 'Please upload standby video!',
  uploadVideoBtn: 'Upload Video',

  standbyImage: 'Standby Image',
  standbyImageBlank: 'Please upload standby image!',
  uploadImageBtn: 'Upload Image',

  standbyBrightnessType: 'Standby Brightness Type',
  standbyBrightnessTypeTxt: 'Choode standby brightness type',
  standbyBrightnessTypeBlank: 'Standby brightness type can\'t be blank!',
  option_followSystem: 'Follow the system',
  option_userDefined: 'User-defined',

  standbyBrightness: 'Standby Brightness',
  standbyBrightnessBlank: 'Standby brightness can\'t be blank!',

  dateAndTimeTitle: 'Date and Time',

  showDateAndTime: 'Show Date and Time',
  showDateAndTimeTxt: 'Choose whether to show date and time',
  showDateAndTimeBlank: 'Choose whether to show date and time!',
  option_true: 'True',
  options_false: 'False',

  syncWay: 'Sync Way',
  syncWayTxt: 'Choose sync way',
  syncWayBlank: 'Sync way can\'t be blank!',
  option_serverSync: 'Server sync',
  option_manualSettings: 'Manual settings',

  setDateAndTime: 'Set Date and Time',
  setDateAndTimeTxt: 'Choose date and time',
  setDateAndTimeBlank: 'Date and time can\'t be blank!',

  dateFormat: 'Date Format',
  dateFormatTxt: 'Choose date format',
  dateFormatTBlank: 'Date format can\'t be blank!',

  timeFormat: 'Time Format',
  timeFormatTxt: 'Choose time format',
  timeFormatBlank: 'Time format can\'t be blank!',
  option_12h: '12h',
  option_24h: '24h',

  companyInfoTitle: 'Company Information',

  showCompanyInfo: 'Show Company Information',
  showCompanyInfoTxt: 'Choose whether to show company information',
  showCompanyInfoWarning: 'Choose whether to show company information!',

  companyName: 'Company Name',
  companyNameTxt: 'Enter company name',
  companyNameBlank: 'Company name can\'t be blank!',
  companyNameWarning: 'Company name is up to 40 words!',

  companyLogo: 'Company Logo',
  companyLogoBlank: 'Please upload company Logo!',
  uploadLogoBtn: 'Upload Logo',

  settingLanguage: 'Setting Language',
  settingLanguageTxt: 'Please setting language',
  settingLanguageWarning: 'Please setting language!',
  option_cn: '简体中文',
  option_us: 'English',

  voiceBroadcastTitle: 'Voice Broadcast',

  enableVoiceBroadcast: 'Enable Voice Broadcast',
  enableVoiceBroadcastTxt: 'Select whether to enable voice broadcasting',
  enableVoiceBroadcastBlank: 'Select whether to enable voice broadcasting!',

  S_cardRecogVoice: 'IC Card Identifying Successful Voice',
  S_cardRecogVoiceTxt: 'Enter IC Card identifying successful voice',
  S_cardRecogVoiceBlank: 'Enter IC Card identifying successful voice!',
  S_cardRecogVoiceWarning: 'The voice is up to 20 words!',
  S_cardRecogVoiceDefault: 'Successful',

  F_cardRecogVoice: 'IC Card Identifying Failure Voice',
  F_cardRecogVoiceTxt: 'Enter IC Card identifying failure voice',
  F_cardRecogVoiceBlank: 'Enter IC Card identifying failure voice!',
  F_cardRecogVoiceWarning: 'The voice is up to 20 words!',
  F_cardRecogVoiceDefault: 'Invalid card',

  faceRecogVoice: 'Voice In Face Recognition',
  faceRecogVoiceTxt: 'Enter the voice in face recognition',
  faceRecogVoiceBlank: 'Enter the voice in face recognition!',
  faceRecogVoiceWarning: 'The voice is up to 20 words!',
  faceRecogVoiceDefault: 'Recognizing',

  S_faceRecogVoice: 'Face Recognition Successful Voice',
  S_faceRecogVoiceTxt: 'Enter face recognition successful voice',
  S_faceRecogVoiceBlank: 'Enter face recognition successful voice!',
  S_faceRecogVoiceWarning: 'The voice is up to 20 words!',
  S_faceRecogVoiceDefault: 'Successful',

  F_faceRecogVoice: 'Face Recognition Failure Voice',
  F_faceRecogVoiceTxt: 'Enter face recognition failure voice',
  F_faceRecogVoiceBlank: 'Enter face recognition failure voice!',
  F_faceRecogVoiceWarning: 'The voice is up to 20 words!',
  F_faceRecogVoiceDefault: 'Failed',
  
  noMaskVoice: 'No-mask Voice',
  noMaskVoiceTxt: 'Enter no-mask voice',
  noMaskVoiceBlank: 'Enter no-mask voice!',
  noMaskVoiceWarning: 'The voice is up to 20 words!',
  noMaskVoiceDefault: 'Please wear mask',

  normothermiaVoice: 'Normothermia Voice',
  normothermiaVoiceTxt: 'Enter normothermia voice',
  normothermiaVoiceBlank: 'Enter normothermia voice!',
  normothermiaVoiceWarning: 'The voice is up to 20 words!',
  normothermiaVoiceDefault: 'Normothermia',

  abnormothermiaVoice: 'Abnormothermia Voice',
  abnormothermiaVoiceTxt: 'Enter abnormothermia voice',
  abnormothermiaVoiceBlank: 'Enter abnormothermia voice!',
  abnormothermiaVoiceWarning: 'The voice is up to 20 words!',
  abnormothermiaVoiceDefault: 'Abnormothermia',

  invalidTimeVoice: 'Invalid Opening Time Voice',
  invalidTimeVoiceTxt: 'Enter invalid opening time voice',
  invalidTimeVoiceBlank: 'Enter invalid opening time voice!',
  invalidTimeVoiceWarning: 'The voice is up to 20 words!',
  invalidTimeVoiceDefault: 'Invalid',

  logCnfigTitle: 'Log file configuration',

  saveDeviceWorkLog: 'Save the device work log',
  saveDeviceWorkLogTxt: 'Select whether to save the device work log',
  saveDeviceWorkLogBlank: 'Select whether to save the device work log!',

  saveUserActionsLog: 'Save the user actions log',
  saveUserActionsLogTxt: 'Select whether to save the user actions log',
  saveUserActionsLogBlank: 'Select whether to save the user actions log!',

  saveDeviceAlarmLog: 'Save the device alarm log',
  saveDeviceAlarmLogTxt: 'Select whether to save the device alarm log',
  saveDeviceAlarmLogBlank: 'Select whether to save the device alarm log!',

  logRetentionDays: 'Log retention days',
  logRetentionDaysBlank: 'Please set the number of log retention days!'
}

export default { zhCN, enUS }